import { tv } from "../foundations/cn.js";
import { FIELD_FOCUS, FIELD_WELL } from "../foundations/interaction.js";

/** The well every text-entry control draws: Input and Textarea. */
export const fieldWellStyles = tv({
  base: ["flex items-center gap-2 px-3.5", FIELD_WELL, FIELD_FOCUS],
  variants: {
    size: { sm: "h-control-sm", md: "h-control-md", lg: "h-control-lg" },
    invalid: { true: "border-status-danger focus-within:border-status-danger" },
    /** A search field stands among controls (a nav, a filter bar), so it takes their shape. */
    search: { true: "rounded-control" },
  },
  defaultVariants: { size: "md" },
});

/**
 * The text inside a well. 16px on touch screens: iOS Safari zooms the page into a field set any
 * smaller.
 */
export const FIELD_TEXT =
  "bg-transparent text-body-b1 outline-none pointer-coarse:text-base pointer-coarse:leading-5 placeholder:text-text-tertiary disabled:cursor-default";
